export const IDENTIFY_USER_REQUEST = 'IDENTIFY_USER_REQUEST';
export const IDENTIFING_USER_SUCCEEDED = 'IDENTIFING_USER_SUCCEEDED';
export const IDENTIFING_USER_FAILED = 'IDENTIFING_USER_FAILED';

export const SUBMIT_CONTACT_FORM_REQUEST = 'SUBMIT_CONTACT_FORM_REQUEST';
export const SUBMITTING_CONTACT_FORM_SUCCEEDED = 'SUBMITTING_CONTACT_FORM_SUCCEEDED';
export const SUBMITTING_CONTACT_FORM_FAILED = 'SUBMITTING_CONTACT_FORM_FAILED';

export const RECORD_QUIZ_RESULT_REQUEST = 'RECORD_QUIZ_RESULT_REQUEST';
export const RECORDING_QUIZ_RESULT_SUCCEEDED = 'RECORDING_QUIZ_RESULT_SUCCEEDED';
export const RECORDING_QUIZ_RESULT_FAILED = 'RECORDING_QUIZ_RESULT_FAILED';